import angular from 'angular'

const setFocus = angular
    .module('app.setFocus', [])

export default setFocus.name
setFocus.directive('setFocus', () => function (scope, element) {
    element[0].focus()
})



// WEBPACK FOOTER //
// ./src/components/setFocus/index.js